import React, { createContext, Fragment, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import useMediaQuery from './hook/useMediaQuery';
import ScrollToTop from 'components/common/ScrollToTop';
import NotFound from 'components/notFound';
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SignUp from 'screens/Login/SignUp';
import PrivateRoutes from 'components/common/PrivateRouter';
import ResetPW from 'screens/Login/ResetPW';
import Login from 'screens/Login';
import Main from 'screens/Main';
import SlomonShip from 'screens/SlomonShip';
import Shipment from 'screens/Shipment';
import Sales from 'screens/Sales';
import EditProfile from 'screens/Mypage/EditProfile';
import ResetPW2 from 'screens/Mypage/ResetPW';
import NormalCreate from 'screens/Quote/Normal/Create';
import NormalConfirm from 'screens/Quote/Normal/Confirm';
import SimpleCreate from 'screens/Quote/Simple/Create';
import SimpleConfrim from 'screens/Quote/Simple/Confrim';
import TransportList from 'screens/Transport/List';
import TransportDetail from 'screens/Transport/Detail';
import SpecialList from 'screens/Special/List';
import SpecialDetail from 'screens/Special/Detail';
import CheckCompany from 'components/common/modal/CheckCompany';
import StatusDetail from 'screens/Quote/Status/Detail';
import StatusList from 'screens/Quote/Status/List';
import TransportIssue from 'screens/Transport/Issue';
import NewsList from 'screens/News/List';
import NewsDetail from 'screens/News/Detail';
import IssueDetail from 'screens/Mypage/Issue/Detail';
import BlList from 'screens/Mypage/Issue/BlList';
import IssueList from 'screens/Mypage/Issue/IssueList';
import EditCompany from 'screens/Mypage/EditCompany';
import Notice from 'screens/Mypage/Notice/List';
import NoticeDetail from 'screens/Mypage/Notice/Detail';
import Notification from 'screens/Mypage/Notification/List';
import SubAccountList from 'screens/Mypage/SubAccount/List';
import SubAccountCreate from 'screens/Mypage/SubAccount/Create';
import SubAccountModify from 'screens/Mypage/SubAccount/Modify';
import SubAccountResetPW from 'screens/Mypage/SubAccount/ResetPW';
import ASList from 'screens/Mypage/AS/List';
import InquiryList from 'screens/Mypage/Inquiry/List';
import InquiryCreate from 'screens/Mypage/Inquiry/Create';
import Privacy from 'screens/Privacy';

interface IGlobalContext {
  isTablet: boolean;
  isMobile: boolean;
}

export const GlobalContext = createContext<IGlobalContext>({
  isTablet: false,
  isMobile: false,
});

const App = () => {
  const isTabletByQuery = useMediaQuery('(max-width: 768px)');
  const isMobileByQuery = useMediaQuery('(max-width: 576px)');
  const [isTablet, setIsTablet] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsTablet(isTabletByQuery);
  }, [isTabletByQuery]);

  useEffect(() => {
    setIsMobile(isMobileByQuery);
  }, [isMobileByQuery]);

  useEffect(() => {
    if (navigator.userAgent.includes("Windows")) {
      const style = document.createElement("style");
      style.innerHTML = `
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: rgba(0,0,0,0.4);
        border-radius: 5px;
      }
      ::-webkit-scrollbar-track {
        background: rgba(255,255,255,0);
      }
    `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <Fragment>
      <GlobalContext.Provider value={{ isTablet, isMobile }}>
        <div className="relative text-black select-none">
          <BrowserRouter>
            <ScrollToTop />
            <CheckCompany />
            <ToastContainer
              position="top-center"
              autoClose={2500}
              limit={6}
              newestOnTop={false}
              closeOnClick={true}
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
              transition={Bounce}
            />
            <Routes>
              {/* public */}
              <Route path='/login' element={<Login />} />
              <Route path='/signup' element={<SignUp />} />
              <Route path='/resetpw' element={<ResetPW />} />
              <Route path='/' element={<Main />} />
              <Route path='*' element={<NotFound />} />
              <Route path='/news/list' element={<NewsList />} />
              <Route path='/news/detail' element={<NewsDetail />} />
              <Route path='/privacy' element={<Privacy />} />

              {/* private */}
              <Route element={<PrivateRoutes />} >
                <Route path='/quote/normal/create' element={<NormalCreate />} />
                <Route path='/quote/normal/confirm' element={<NormalConfirm />} />
                <Route path='/quote/simple/create' element={<SimpleCreate />} />
                <Route path='/quote/simple/confirm' element={<SimpleConfrim />} />
                <Route path='/quote/status/list' element={<StatusList />} />
                <Route path='/quote/status/detail' element={<StatusDetail />} />
                <Route path='/shipment' element={<Shipment />} />
                <Route path='/transport/list' element={<TransportList />} />
                <Route path='/transport/detail' element={<TransportDetail />} />
                <Route path='/transport/issue' element={<TransportIssue />} />
                <Route path='/sales' element={<Sales />} />
                <Route path='/special/list' element={<SpecialList />} />
                <Route path='/special/detail' element={<SpecialDetail />} />
                <Route path='/solomonShip' element={<SlomonShip />} />
                <Route path='/mypage/editProfile' element={<EditProfile />} />
                <Route path='/mypage/resetPW' element={<ResetPW2 />} />
                <Route path='/mypage/notice/list' element={<Notice />} />
                <Route path='/mypage/notice/detail' element={<NoticeDetail />} />
                <Route path='/mypage/notification/list' element={<Notification />} />
                <Route path='/mypage/editCompany' element={<EditCompany />} />
                <Route path='/mypage/issue/blList' element={<BlList />} />
                <Route path='/mypage/issue/issueList' element={<IssueList />} />
                <Route path='/mypage/issue/detail' element={<IssueDetail />} />
                <Route path='/mypage/subAccount/list' element={<SubAccountList />} />
                <Route path='/mypage/subAccount/create' element={<SubAccountCreate />} />
                <Route path='/mypage/subAccount/modify' element={<SubAccountModify />} />
                <Route path='/mypage/subAccount/modify/reset' element={<SubAccountResetPW />} />
                <Route path='/mypage/as/list' element={<ASList />} />
                <Route path='/mypage/inquiry/list' element={<InquiryList />} />
                <Route path='/mypage/inquiry/create' element={<InquiryCreate />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </GlobalContext.Provider>
    </Fragment>
  );
}

export default App;
